export default {"src":"/_next/static/media/bits-white-logo.aa361468.svg","height":500,"width":500};